import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompetitiveRates = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "competitiveRates",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17298",
		"data-name": "Group 17298",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12648",
				"data-name": "Path 12648",
				d: "M18.429,17H5.571A2.571,2.571,0,0,1,3,14.429V5.571A2.571,2.571,0,0,1,5.571,3H18.428A2.571,2.571,0,0,1,21,5.571v8.857A2.571,2.571,0,0,1,18.429,17Z",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12649",
				"data-name": "Path 12649",
				d: "M14,17l.5,4",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12650",
				"data-name": "Path 12650",
				d: "M10,17l-.5,4",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12651",
				"data-name": "Path 12651",
				d: "M8.14,21h7.72",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12671",
				"data-name": "Path 12671",
				d: "M9.667,9.333,8,11,7,10",
				transform: "translate(0.501 -2.167)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12673",
				"data-name": "Path 12673",
				d: "M13,10h3",
				transform: "translate(0.501 -2.167)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12674",
				"data-name": "Path 12674",
				d: "M9.667,13.333,8,15,7,14",
				transform: "translate(0.501 -2.167)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12675",
				"data-name": "Path 12675",
				d: "M13,14h3",
				transform: "translate(0.501 -2.167)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12655",
		"data-name": "Path 12655",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgCompetitiveRates;
